import { render, staticRenderFns } from "./PayslipsPDF.vue?vue&type=template&id=4408c9e7&scoped=true"
import script from "./PayslipsPDF.vue?vue&type=script&lang=js"
export * from "./PayslipsPDF.vue?vue&type=script&lang=js"
import style0 from "./PayslipsPDF.vue?vue&type=style&index=0&id=4408c9e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4408c9e7",
  null
  
)

export default component.exports